module.exports = __webpack_public_path__ + "static/img/bg_b.e2eb616f.png";